import { PageHeader, Tooltip } from 'antd'
import * as React from 'react'

import { Conversation } from '../dtos'
import { FavoriteFilledIcon, FavoriteIcon } from '../../icons'

import * as styles from './Header.module.less'

export interface HeaderProps {
    bookmarkConversation: (conversationId: string) => void
    conversation: Conversation
    onGoToConversationsClick?: () => void
    user: { id: string }
}

export const Header: React.FC<HeaderProps> = (props) => {
    const bookmark = () => {
        props.bookmarkConversation(props.conversation.id)
    }

    const isBookmarkedByUser: boolean =
        props.conversation.bookmarkedBy.find(
            (u) => u.oauthId === props.user.id
        ) !== undefined
            ? true
            : false

    return (
        <div className={styles.header}>
            <PageHeader
                onBack={
                    props.onGoToConversationsClick !== undefined
                        ? () =>
                              props.onGoToConversationsClick &&
                              props.onGoToConversationsClick()
                        : undefined
                }
                title={
                    <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
                        {props.conversation.title}
                    </span>
                }
                subTitle={
                    <span style={{ paddingLeft: 8, cursor: 'auto' }}>
                        <Tooltip title="bookmark">
                            {isBookmarkedByUser ? (
                                <FavoriteFilledIcon
                                    onClick={bookmark}
                                    style={{
                                        color: isBookmarkedByUser
                                            ? '#fadb14'
                                            : '#ccc'
                                    }}
                                />
                            ) : (
                                <FavoriteIcon
                                    onClick={bookmark}
                                    style={{
                                        color: isBookmarkedByUser
                                            ? '#fadb14'
                                            : '#ccc'
                                    }}
                                />
                            )}
                        </Tooltip>
                    </span>
                }
            />
        </div>
    )
}
